import React from 'react';
import PropTypes from 'prop-types';

import Title from 'airbnb-dls-web/build/exp/Title';
import Tabs, { Tab } from 'airbnb-dls-web/build/exp/Tabs';
import Column from 'airbnb-dls-web/build/exp/Column';
import ColumnRow from 'airbnb-dls-web/build/exp/ColumnRow';
import IconListUl from 'airbnb-dls-web/build/exp/icons/IconListUl';
import IconFilter from 'airbnb-dls-web/build/exp/icons/IconFilter';
import IconPerformance from 'airbnb-dls-web/build/exp/icons/IconPerformance';
import IconAndroid from 'airbnb-dls-web/build/exp/icons/IconAndroid';
import IconCode from 'airbnb-dls-web/build/exp/icons/IconCode';
import IconBook from 'airbnb-dls-web/build/exp/icons/IconBook';
import IconThumbsUp from 'airbnb-dls-web/build/exp/icons/IconThumbsUp';
import Text from 'airbnb-dls-web/build/exp/Text';
import Labeled from 'airbnb-dls-web/build/exp/Labeled';
import HeadingSection from 'airbnb-dls-web/build/exp/HeadingSection';

import Panel from 'airbnb-dls-web/build/exp/Panel';
import IconDrawerSettings from 'airbnb-dls-web/build/exp/icons/IconDrawerSettings';
import Spacing from 'airbnb-dls-web/build/exp/Spacing';
import ProjectCard from '../components/ProjectCard';
import FeaturedProjects from '../components/FeaturedProjects';
import CenterText from '../components/CenterText';
import Link from '../components/Link';

const SHOW_FEATURED_PROJECTS = false;

const propTypes = {
  data: PropTypes.object.isRequired,
};

const ALL_PROJECTS_TAG_ID = Symbol('all_tags_id');

const TABS = [
  {
    name: 'All projects',
    icon: <IconListUl decorative />,
    tagId: ALL_PROJECTS_TAG_ID,
  },

  {
    name: 'Data',
    tagId: 'data',
    icon: <IconPerformance decorative />,
  },

  {
    name: 'Backend',
    tagId: 'backend',
    icon: <IconFilter decorative />,
  },

  {
    name: 'Frontend',
    tagId: 'frontend',
    icon: <IconCode decorative />,
  },

  {
    name: 'Mobile',
    tagId: 'mobile',
    icon: <IconAndroid decorative />,
  },

  {
    name: 'Infrastructure',
    tagId: 'infrastructure',
    icon: <IconDrawerSettings decorative />,
  },

  {
    name: 'Style guides',
    tagId: 'styleguides',
    icon: <IconBook decorative />,
  },

  {
    name: 'Testing',
    tagId: 'testing',
    icon: <IconThumbsUp decorative />,
  },
];

function getProjectsForTab(projects, tab) {
  return projects.filter(
    project => (tab.tagId === ALL_PROJECTS_TAG_ID ? true : project.tags === tab.tagId),
  );
}

export default class ProjectsHomepage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
    };
    this.handlePressTab = this.handlePressTab.bind(this);
  }

  handlePressTab(newTabValue) {
    this.setState({ tabValue: newTabValue });
  }

  render() {
    const { data: { allFeaturedProjectsYaml, allMarkdownRemark } } = this.props;
    const projects = allMarkdownRemark.edges.map(projectEdge => projectEdge.node.frontmatter);
    const featuredProjectIds = allFeaturedProjectsYaml.edges.map(
      featuredProjectEdge => featuredProjectEdge.node.id,
    );

    return (
      <HeadingSection>
        <Spacing top={5} bottom={8}>
          <Spacing top={5} bottom={0}>
            <Title level={2}>Open Source</Title>
          </Spacing>
          <Text light muted>
            Open source is at the heart of what we do at Airbnb

            <ul>
              <li><Link href="./codeofconduct/">Code of Conduct</Link></li>
              <li><Link href="https://opencollective.com/airbnb">Sponsored Projects</Link></li>
            </ul>
          </Text>
        </Spacing>

        {SHOW_FEATURED_PROJECTS && (
          <Spacing bottom={8}>
            <CenterText>
              <Panel>
                <Spacing vertical={3}>
                  <Spacing bottom={4}>
                    <Title level={3}>Featured Projects</Title>
                  </Spacing>
                  <FeaturedProjects projects={projects} featuredProjectIds={featuredProjectIds} />
                </Spacing>
              </Panel>
            </CenterText>
          </Spacing>
        )}

        <Spacing>
          <Tabs scrollable value={this.state.tabValue} onPressTab={this.handlePressTab}>
            {TABS.map(tab => (
              <Tab key={tab.name} label={<Labeled before={tab.icon}>{tab.name}</Labeled>}>
                <Spacing top={6}>
                  <ColumnRow>
                    {getProjectsForTab(projects, tab).map((project, index) => (
                      <Column sm={12} md={4} lg={3} key={project.title}>
                        <Spacing bottom={8}>
                          <ProjectCard index={index} {...project} />
                        </Spacing>
                      </Column>
                    ))}
                  </ColumnRow>
                </Spacing>
              </Tab>
            ))}
          </Tabs>
        </Spacing>
      </HeadingSection>
    );
  }
}

ProjectsHomepage.propTypes = propTypes;

export const pageQuery = graphql`
  query ProjectsPageQuery {
    allFeaturedProjectsYaml {
      edges {
        node {
          id
        }
      }
    }
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            id
            title
            logo
            description
            stars
            forks
            tags
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/projects.jsx